import useLoadNotifications from "./useLoadNotifications";

const HomeNotificationContainer: React.FC = () => {
  useLoadNotifications();
  return null;
};

export default HomeNotificationContainer;
